<template>
  <j-modal
    :title="language['system.languageManagement']"
    :width="700"
    :visible="visible"
    switchFullscreen
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="language['common.okButton']"
    :ok-disabled="isDisabled"
    :okButtonProps="{ class:{'jee-hidden': isDisabled} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model>
        <div v-for="(item,index) in languagelist" :key="index">
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language[item.templateLangCode]">
            <a-input type="text" v-model="item.langTrans" maxLength="maxLength" :disabled="isDisabled||disabled"/>
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-spin>
  </j-modal>

</template>

<script>
import { getAction } from '@api/manage'
export default {
  name: "LanguageModel",
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    maxLength: {
      type: Number,
      default: 100000,
      required: false
    }
  },
  data(){
    return {
      visible: false,
      confirmLoading: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      languagelist:[
        {templateLangCode:'zh_CN',langTrans:''},
        {templateLangCode:'zh_TW',langTrans:''},
        {templateLangCode:'en_US',langTrans:''},
        {templateLangCode:'vi_VN',langTrans:''},
      ],
      applicationId:'',
      dataTable:'',
      dataColumn:'',
      dataId:'',
      isDisabled:false,
    }
  },
  created() {
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods:{
    edit(applicationCode,dataTable,dataColumn,dataId,languagelist,isDisabled){
      console.log("languagelist：",languagelist)
      getAction("/sys/sysBmApplication/queryByCode",{"code":applicationCode}).then((res) => {
        if(res.success){
          if(isDisabled){
            this.isDisabled = isDisabled;
          }
          this.visible = true
          this.applicationId = res.result.id
          this.dataTable = dataTable
          this.dataColumn = dataColumn
          this.dataId = dataId
          if(languagelist && languagelist.length>0){
            this.languagelist = languagelist
          }

          // this.initLanguagetemp(res.result.id,dataTable,dataColumn,dataId)
        }
      })


    },
    handleOk(){
      let list = [];
      this.languagelist.forEach(item=>{
          item.applicationId = this.applicationId
          item.dataTable = this.dataTable
          item.dataColumn = this.dataColumn
          item.dataId = this.dataId
          item.langTrans = item.langTrans?item.langTrans.trim():'';
          list.push(item);
      })
      let map = {
        applicationId:this.applicationId,
        dataTable:this.dataTable,
        dataColumn:this.dataColumn,
        dataId:this.dataId,
        languagelist:list
      }
      this.$emit('ok',map);
      this.close();
    },
    handleCancel(){
      this.close();
    },
    close(){
      this.visible = false
    },
    initLanguagetemp(applicationId,dataTable,dataColumn,dataId){
      let that = this;
      getAction("/sys/syslanguagedata/querylistby", {applicationId:applicationId,dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=>{
        if(res.success){
          this.languagelist = res.result;
          /*this.languagelist = this.$store.getters.languagelist
          let list = res.result;
          let languageTemplate = this.$store.getters.languagelist

          for(var i=0;i<list.length;i++){
            for(var j=0;j<this.languagelist.length;j++){
              if(this.languagelist[j].value == list[i].langCode){
                this.languagelist[i]
              }
            }
          }*/


          /*for(var i=0;i<this.languagelist.length;i++){
            let boo = true;
            for(var j=0;j<list.length;j++){
              if(this.languagelist[i].value == list[j].langCode){
                this.languagelist[i].syslanguagedata = list[j];
                list.splice(j,1)
                boo = false;
                break;
              }
            }
            if(boo){
              this.languagelist[i].syslanguagedata = {langTrans :''};
            }
          }*/
        }else{
        }
      });
    },
  }
}
</script>

<style scoped>

</style>